import React, { PureComponent } from "react";
import Parser from "html-react-parser";

import RichTextWrapper from "./styled-components";
import { RenderRichText } from "../../_static/richTextEditorResolver";

class RichText extends PureComponent {
  static defaultProps = {
    content: {
      isModule: false,
      markdown: "",
      textCentered: false
    },
    qaLabel: "richText"
  };

  render() {
    const { qaLabel, content } = this.props;
    const { isModule, markdown, textCentered } = content;

    const listOfContents = [];
    if (typeof markdown !== "string") {
      markdown.content.forEach((blok) => listOfContents.push(blok));
    } else {
      return (
        <RichTextWrapper
          isModule={isModule}
          textCentered={textCentered}
          data-qa-label={qaLabel}
        >
          {Parser(markdown)}
        </RichTextWrapper>
      );
    }

    return (
      <RichTextWrapper
        data-qa-label={qaLabel}
        isModule={isModule}
        textCentered={textCentered}
      >
        {listOfContents.map((blok) => RenderRichText(blok))}
      </RichTextWrapper>
    );
  }
}

export default RichText;
